import { render, staticRenderFns } from "./boardAllLeft.vue?vue&type=template&id=9efee994&scoped=true&"
import script from "./boardAllLeft.vue?vue&type=script&lang=js&"
export * from "./boardAllLeft.vue?vue&type=script&lang=js&"
import style0 from "./boardAllLeft.vue?vue&type=style&index=0&id=9efee994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efee994",
  null
  
)

export default component.exports